import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getComparison } from "api/Finances";

export const useComparison = (filter_date: { year: number, month: number }) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['comparison', filter_date],
        () => {
            return getComparison({
                filter_date: filter_date.year + '-' + filter_date.month,
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
